<script lang="ts">
  import { Toast, ToastHeader } from "sveltestrap";

  export let title: string;
  export let isOpen = false;
  export let success:boolean;
</script>

<Toast autohide body {isOpen} on:close={() => (isOpen = false)}>
  <ToastHeader icon="{success ? "success" : "danger"}">{title}</ToastHeader>
  <div class="content">
    <slot />
  </div>
</Toast>

<style>
  .content {
    color: black;
  }
</style>
